import React from 'react';
import PropTypes from 'prop-types';
import {FormattedNumber} from 'react-intl';

import NANCheck from '@stubhub/react-is-nan';
import {BubblesSkeleton} from '@stubhub/react-skeletons';
import {DEFAULT_CURRENCY_CODE} from '@stubhub/react-store-default-currency';

import '../styles/index.scss';

const PriceDisplay = ({isLoading, currency = DEFAULT_CURRENCY_CODE, price, decimalPlaces = 0, className}) => {
  return isLoading ? (
    <BubblesSkeleton className="PriceDisplay__skeleton" />
  ) : (
    <NANCheck value={price}>
      <FormattedNumber
        className={className}
        style="currency"
        maximumFractionDigits={decimalPlaces}
        minimumFractionDigits={decimalPlaces}
        currencyDisplay="symbol"
        currency={currency}
        useGrouping
        value={price}
      />
    </NANCheck>
  );
};

PriceDisplay.propTypes = {
  isLoading: PropTypes.bool,
  currency: PropTypes.string,
  price: PropTypes.number,
  decimalPlaces: PropTypes.number,
  className: PropTypes.string,
};

export default PriceDisplay;
